import React from 'react';
import Pagination from '../components/Pagination';
import Spinner from '../components/Spinner';
import ProjectGallery from '../components/ProjectGallery';
import { useProjectLibraryContext } from '../contexts/ProjectLibraryContext';
import ProjectLibraryControlContainer from '../components/ProjectLibraryControlContainer';
import useURLParams from '../hooks/useURLParams';
import CreateProjectModal from '../components/CreateProjectModal';

const ProjectLibrary: React.FC = () => {
    const projectLibraryContext = useProjectLibraryContext();

    const isLoading = projectLibraryContext.state.isLoading;

    const projects = projectLibraryContext.state.projects;

    const isPrevPageAvailable = projectLibraryContext.state.currentPage > 1;
    const isNextPageAvailable =
        projectLibraryContext.state.currentPage <
        projectLibraryContext.state.totalPages;

    const { getParam } = useURLParams();

    return (
        <>
            {getParam('modal') === 'create' && <CreateProjectModal />}

            <div className="wrapper-container">
                <ProjectLibraryControlContainer />
                {!isLoading ? <ProjectGallery /> : <Spinner />}
                {projects.length > 0 && (
                    <Pagination
                        totalPages={projectLibraryContext.state.totalPages}
                        isPrevPageAvailable={isPrevPageAvailable}
                        isNextPageAvailable={isNextPageAvailable}
                        currentPage={projectLibraryContext.state.currentPage}
                    />
                )}
            </div>
        </>
    );
};

export default ProjectLibrary;
